import mixpanel from "mixpanel-browser";
import { Urls } from "../Urls";
import { UserDetailsContext } from "../UserDetailsContext";
import { useContext } from "react";
import { MyCompanyProfileContext } from "../MyCompanyProfileContext";

export const useMixPanelForTracking = () => {
  const [userDetails] = useContext(UserDetailsContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const TrackMixPanel = ({
    ModuleName,
    ScreenName,
    Data = "None",
    Definition,
  }) => {
    mixpanel.track(Definition, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ModuleName: ModuleName,
      ScreenName: ScreenName,
      ClientIP: sessionStorage.getItem("ClientIP"),
      Data: Data,
      UserName: userDetails?.user_details?.name,
      UserEmail:
        userDetails?.user_details?.email ||
        userDetails?.user_details?.emails[0],
      CompanyName: companySettingData?.company_name,
    });
  };

  return { TrackMixPanel };
};
